module.exports = __webpack_public_path__ + "static/media/design.8da09fef.svg";